import Card from '@ergeon/core-components/exports/Card.ts';
import Link from '@ergeon/core-components/exports/Link.ts';
import { PRIVACY_POLICY_URL } from '@ergeon/core-components/exports/constants.ts';

import { DEPLOY_LEVEL } from '@/app/config';
import { cn } from '@/lib/utils';

// The notice is reference material rather than a call to action, so its weight
// comes off the type and the padding, not the container: "regular" is the
// design system's own subtle-background flavour and is left unoverridden — a
// className background loses to the one Card sets for its flavour.
const LEAD_IN = 'font-bold text-gray-900 dark:text-gray-200';

function privacyPolicyHref() {
  if (DEPLOY_LEVEL === 'production') {
    return PRIVACY_POLICY_URL.production;
  }

  return PRIVACY_POLICY_URL.develop;
}

export default function ConsentNotice() {
  return (
    <Card
      className="flex-col gap-2 px-5 py-4"
      flavor="regular"
      rounded="medium"
      tag="section">
      <h2 className="paragraph-2 font-bold text-gray-900 dark:text-gray-100">
        Recording notice
      </h2>
      {/* Bullets hang outside the text column so a wrapped line lines up with
          the line above it instead of sliding back under the marker. */}
      <ul
        className={cn(
          'paragraph-3 list-outside list-disc space-y-1.5 pl-4',
          'text-gray-600 marker:text-gray-400 dark:text-gray-400 dark:marker:text-gray-600',
        )}>
        <li>
          <strong className={LEAD_IN}>Recorded and transcribed</strong> for
          quality assurance, training, and project preparation.
        </li>
        <li>
          <strong className={LEAD_IN}>Location is mapped to the video</strong> —
          your phone&rsquo;s location during the walkthrough is recorded too.
        </li>
        <li>
          <strong className={LEAD_IN}>Joining is your consent</strong> — if you
          do not consent, please do not join the call. See our{' '}
          <Link
            href={privacyPolicyHref()}
            rel="noopener noreferrer"
            target="_blank">
            privacy policy
          </Link>{' '}
          for how your data is handled.
        </li>
      </ul>
    </Card>
  );
}
